import { useState } from "react";
import { FiMenu } from "react-icons/fi";
import Sidebar from "../sideBar/Sidebar";
import SubscriptionBanner from "./SubscriptionBanner";
import { SubscriptionProvider } from "../../../context/SubscriptionContext";
import styles from "./MainLayout.module.css";

// There is deliberately NO navigation gate on an expired subscription. An expired tenant may
// browse everywhere; enforcement happens per ACTION — anything that consumes a limit (schedule
// exam, add student, AI questions, PDF pages, video) hits the entitlement check, which returns
// SUBSCRIPTION_LIMIT_REACHED and opens the upsell modal. This mirrors the backend, whose
// SubscriptionGuardFilter was retired to a pass-through for the same reason: read-only access to
// data the tenant already paid to create should never be held hostage to a lapsed plan. The red
// SubscriptionBanner below is the (non-blocking) renewal prompt.

const COLLAPSE_KEY = "gredus.sidebarCollapsed";

const MainLayout = ({ children }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  // Desktop-only collapse (icon rail). Persisted so the choice survives navigation/reload.
  const [isCollapsed, setIsCollapsed] = useState(() => {
    try {
      return localStorage.getItem(COLLAPSE_KEY) === "1";
    } catch {
      return false;
    }
  });

  const openSidebar = () => setIsSidebarOpen(true);
  const closeSidebar = () => setIsSidebarOpen(false);
  const toggleCollapse = () =>
    setIsCollapsed((prev) => {
      const next = !prev;
      try {
        localStorage.setItem(COLLAPSE_KEY, next ? "1" : "0");
      } catch {
        /* ignore storage failures */
      }
      return next;
    });

  return (
    <SubscriptionProvider>
      <div className={`${styles.layout} ${isCollapsed ? styles.layoutCollapsed : ""}`}>
        <Sidebar
          isMobileOpen={isSidebarOpen}
          onMobileClose={closeSidebar}
          collapsed={isCollapsed}
          onToggleCollapse={toggleCollapse}
        />

        <main className={styles.main}>
          <SubscriptionBanner />
          <header className={styles.mobileHeader}>
            <button type="button" className={styles.menuButton} onClick={openSidebar}>
              <FiMenu size={24} />
            </button>
          </header>

          {children}
        </main>
      </div>
    </SubscriptionProvider>
  );
};

export default MainLayout;
